import React from 'react';
import { IContentSidebar } from './interfaces';
import { Stack } from '@mui/material';

export const ContentSidebar: React.FC<IContentSidebar> = ({
  children,
}): JSX.Element => {
  return <Stack gap="10px">{children}</Stack>;
};
